export default {
  create_title: 'Ny Partner API-konto',
  edit_title: 'Rediger konto',
  form: {
    name: 'Kontonavn',
    name_placeholder: 'f.eks. Acme POS-integration',
    contact_email: 'Kontakt-e-mail',
    scope: 'Restaurantadgang',
    companies: 'Restauranter',
    scope_selected: 'Udvalgte restauranter',
    scope_all: 'Alle restauranter',
    scope_all_help:
      'Nøgler på denne konto har adgang til alle restauranter i din organisation, også dem, der registreres senere.',
    companies_help: 'Nøgler udstedt på denne konto kan kun læse og skrive til disse restauranter.',
    is_active: 'Aktiv',
    is_active_help: 'Inaktive konti afvises ved godkendelse.',
  },
  buttons: {
    cancel: 'Annullér',
    save: 'Gem',
    create: 'Opret',
  },
  toasts: {
    created: 'Partner API-konto oprettet.',
    updated: 'Konto opdateret.',
    error: 'Kontoen kunne ikke gemmes.',
  },
};
